// Helper condiviso fra CreateAccessForm (portale progetti) e PartnerPortalSection
// (portale partner): entrambi generano una password casuale lato client per il
// flusso "Nuova password" / creazione accesso. Prima viveva solo dentro
// CreateAccessForm.tsx ed era importata da lì anche per il portale partner.
export function generatePassword(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  let password = '';
  for (let i = 0; i < 10; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
}
